module.exports = __webpack_public_path__ + "static/media/gait-analysis.45ab82d2.jpg";